// 31/10 (cliente) : fiche produit.
// « Partager ce modèle » (ordinateur et téléphone) : feuille de partage de l'appareil, sinon copie du lien.
// Barre d'achat du bas (téléphone) : petite photo et couleur choisies, repris du thème Chantier (27/10).
(function () {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mf-share]');
    if (!btn) return;
    const label = btn.querySelector('span');
    const url = location.origin + location.pathname;
    try {
      if (navigator.share) { await navigator.share({ title: btn.dataset.title || document.title, url }); return; }
      await navigator.clipboard.writeText(url);
      label.textContent = 'Lien copié';
      setTimeout(() => { label.textContent = 'Partager ce modèle'; }, 2500);
    } catch (err) { /* partage annulé */ }
  });

  if (!window.matchMedia('(max-width: 749px)').matches) return;
  const info = document.querySelector('.product__info-container');
  const sticky = document.querySelector('mf-sticky-atc');
  const handle = location.pathname.split('/products/')[1];
  if (!info || !sticky || !handle) return;
  let product;
  const current = () => {
    const id = (info.querySelector('form[action*="/cart/add"] input[name="id"]') || {}).value;
    return product.variants.find((v) => String(v.id) === String(id)) || product.variants[0];
  };
  const sync = () => {
    const cur = current();
    const opts = [...info.querySelectorAll('variant-selects input[type="radio"]:checked')].map((i) => i.value);
    let line = sticky.querySelector('.mf-sticky-atc__opts');
    if (!line) {
      line = document.createElement('p');
      line.className = 'mf-sticky-atc__opts';
      const price = sticky.querySelector('.mf-sticky-atc__price');
      if (price) price.after(line);
    }
    if (line.textContent !== opts.join(' · ')) line.textContent = opts.join(' · ');
    let th = sticky.querySelector('.mf-sticky-atc__thumb');
    if (!th) {
      th = document.createElement('img');
      th.className = 'mf-sticky-atc__thumb';
      th.alt = ''; th.width = 44; th.height = 44;
      sticky.querySelector('.mf-sticky-atc__inner').prepend(th);
    }
    const src = (cur && cur.featured_image && cur.featured_image.src) || product.featured_image || '';
    if (src) {
      const want = src + (src.includes('?') ? '&' : '?') + 'width=120';
      if (th.getAttribute('src') !== want) th.src = want;
    }
  };
  fetch('/products/' + handle.split('?')[0] + '.js')
    .then((r) => r.json())
    .then((p) => {
      product = p;
      // Dawn redessine les options à chaque choix : on resynchronise après chaque changement
      let t;
      const mo = new MutationObserver(() => { clearTimeout(t); t = setTimeout(sync, 60); });
      sync();
      mo.observe(info, { childList: true, subtree: true });
    })
    .catch(() => {});
})();
